(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[388],{

/***/ 69413:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/innovate",
      function () {
        return __webpack_require__(10498);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28082);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25838);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51411);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54013);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2261);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);












var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), select_cate = ref1[0], setSelectCate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), details = ref2[0], setDetails = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(5), perView = ref3[0], setPerView = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), imageList = ref4[0], setImageList = ref4[1];
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__/* .useTranslations */ .T_)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var $swiper = (0,swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .useSwiper */ .oc)();
    console.log(navDetail, "navDetail");
    // t('common.title') 是多语言的方法，在locales下有对应的cn和en文件
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        var ref, _data, list, id;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/getEventList", {
                            params: {
                                category_name: navDetail.name
                            }
                        })
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, list = _data.data.list;
                    if (list.length) {
                        id = list[0].id;
                        setData(list);
                        setSelectCate(id);
                        getDetails(id);
                    }
                    return [
                        2
                    ];
            }
        });
    }), []);
    var getDetails = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(event_id) {
            var ref, data, content_cn, content_en, img_start, img_end, img_code, style_code, editor_code, view_code, urlRegex, imgSrcs, img_start1, img_end1, img_code1, style_code1, editor_code1, view_code1, urlRegex1, imgSrcs1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request.get("/getEvent", {
                                params: {
                                    id: event_id
                                }
                            })
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data.data;
                        content_cn = data.content_cn, content_en = data.content_en;
                        if (content_cn.indexOf('<div class="meetTitle') !== -1) {
                            img_start = content_cn.indexOf("<p>");
                            img_end = content_cn.indexOf('<div class="meetTitle"');
                            img_code = content_cn.slice(img_start, img_end);
                            style_code = content_cn.slice(0, img_start);
                            editor_code = content_cn.slice(img_end);
                            view_code = style_code + editor_code;
                            data.content_cn = view_code;
                            urlRegex = /https?:\/\/[^\s"'<>]+/g;
                            imgSrcs = img_code.match(urlRegex);
                            setImageList(imgSrcs);
                        }
                        if (content_en.indexOf('<div class="meetTitle') !== -1) {
                            img_start1 = content_en.indexOf("<p>");
                            img_end1 = content_en.indexOf('<div class="meetTitle"');
                            img_code1 = content_en.slice(img_start1, img_end1);
                            style_code1 = content_en.slice(0, img_start1);
                            editor_code1 = content_en.slice(img_end1);
                            view_code1 = style_code1 + editor_code1;
                            data.content_en = view_code1;
                            urlRegex1 = /https?:\/\/[^\s"'<>]+/g;
                            imgSrcs1 = img_code1.match(urlRegex1);
                            setImageList(imgSrcs1);
                        }
                        swiperRef.current.swiper.slideTo(0);
                        setDetails(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function(event_id) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var selectCateItem = function(cate_id) {
        setSelectCate(cate_id);
        getDetails(cate_id);
    };
    var prev = function() {
        swiperRef.current.swiper.slidePrev();
    };
    var next = function() {
        swiperRef.current.swiper.slideNext();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getData();
        if (document.documentElement.clientWidth < 888) {
            setPerView(3);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_2__/* .PageLayout */ .X, {
        temp: "page_crumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_3__/* .getHead */ .c)(navDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().tabs),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cateBox),
                        children: data.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cateItem), " ").concat(item.id == select_cate ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().cateActive) : ""),
                                onClick: function(e) {
                                    return selectCateItem(item.id);
                                },
                                children: item["name_".concat(router.locale)]
                            }, item.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().body),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().bodyBox),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleBox),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/symbol-left-dot.png"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleText),
                                                children: details["name_".concat(router.locale)]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/symbol-right-dot.png"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/image/symbol.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().description),
                                children: details["brief_".concat(router.locale)]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiper),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                        spaceBetween: 14,
                                        slidesPerView: perView,
                                        ref: swiperRef,
                                        children: imageList.map(function(item) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().imageItem),
                                                    src: item
                                                })
                                            }, item);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        onClick: function() {
                                            return prev();
                                        },
                                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().left)),
                                        src: "/image/left-arrow.png"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        onClick: function() {
                                            return next();
                                        },
                                        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), " ").concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().right)),
                                        src: "/image/right-arrow.png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().editor),
                                dangerouslySetInnerHTML: {
                                    __html: details["content_".concat(router.locale)]
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 51411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"innovate_m-1480__QQZnP","container":"innovate_container__EDxAR","tabs":"innovate_tabs__cKIzG","cateBox":"innovate_cateBox__rlzF5","cateItem":"innovate_cateItem__rf6a0","cateActive":"innovate_cateActive__fKV4k","body":"innovate_body__VcfRC","bodyBox":"innovate_bodyBox__R_QX9","title":"innovate_title__vQFQX","titleBox":"innovate_titleBox__FbT_Z","titleText":"innovate_titleText__rMKcO","description":"innovate_description__uycsg","swiper":"innovate_swiper___eOGb","imageItem":"innovate_imageItem__luaQA","btn":"innovate_btn__YCDuR","left":"innovate_left__eiYsm","right":"innovate_right__N_lR8","devide":"innovate_devide__T1vCQ","editor":"innovate_editor__mcXff","imageBox":"innovate_imageBox__YLVpU","rowItem":"innovate_rowItem__F9_cT","groupImage":"innovate_groupImage__F_BUO","topImage":"innovate_topImage__8b0jt","bottomImage":"innovate_bottomImage__1DVWw","space":"innovate_space__fe_bn","meetTitle":"innovate_meetTitle__2Qhj2","infoItem":"innovate_infoItem__yeluK","label":"innovate_label__3mBHn","tag":"innovate_tag__M_iwi","other":"innovate_other__zP0i5","value":"innovate_value__m8IaN","otherValue":"innovate_otherValue__hQU7W","schedule":"innovate_schedule__bP4Ex","scheduleContent":"innovate_scheduleContent__ZfR1d","scheduleItem":"innovate_scheduleItem__t8_yG","scheduleTitle":"innovate_scheduleTitle__g3QlE","scroll":"innovate_scroll__n_hi6","contentHeader":"innovate_contentHeader__aiZN9","middleDivide":"innovate_middleDivide__5yOuh","contentBody":"innovate_contentBody__iEN_C","divide":"innovate_divide__ZME9F","itemBackground":"innovate_itemBackground__Jmvc1","time":"innovate_time__7jvyN","spots":"innovate_spots__0nBo1","item":"innovate_item__xZTXj","scrollBody":"innovate_scrollBody__N0UnF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,912,774,888,179], function() { return __webpack_exec__(69413); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);